import {Box, Button, Modal, Typography} from '@viptech/react-components'
import {useSnackbar} from 'notistack'
import {useState} from 'react'
import {Icon} from 'src/common/generics/components/icon/IconBase'
import CloseIcon from 'src/images/closeBlueIcon.svg'
import api from 'src/services/api'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'
import {Input} from '../../../../components/input/Input'

type CreatePlateProps = {
  isOpen: boolean
  closeModal: () => void
  listId: number
  refreshList: () => void
}

function CreatePlateModal(props: CreatePlateProps) {
  const {isOpen, closeModal, listId, refreshList} = props
  const [plate, setPlate] = useState('')
  const [description, setDescription] = useState('')
  const {enqueueSnackbar} = useSnackbar()

  function handleClose() {
    setPlate('')
    setDescription('')
    closeModal()
  }

  async function handleSaveList() {
    try {
      await api.lpr.createPlate(String(listId), {
        licensePlate: plate,
        description,
      })
      enqueueSnackbar('Placa vinculada com sucesso', {variant: 'success'})
      refreshList()
      handleClose()
    } catch (err) {
      handleErrorWithSnackbar(enqueueSnackbar, err, 'Erro ao vincular placa')
    }
  }

  function plateIsValid(value: string) {
    const validPlate = /^[A-Z]{3}[0-9]{1}[A-Z0-9]{1}[0-9]{2}$/i.test(value) ? value : ''
    if (!validPlate) enqueueSnackbar('Informe uma placa válida', {variant: 'info'})
    else {
      setErrorMessage(undefined)
      setPlate(value)
    }
    return validPlate
  }

  const [errorMessage, setErrorMessage] = useState<string | undefined>()

  return (
    <Modal isOpen={isOpen} closeModal={() => handleClose()} backgroundColor='white'>
      <Box padding='20px' display='flex' direction='column' justifyContent='space-between' height='350px' width='400px'>
        <Box display='flex' justifyContent='space-between'>
          <Typography variant='p' weight={500} size='20px' color='#344054'>
            Cadastro de Placa
          </Typography>

          <Icon src={CloseIcon} cursor='pointer' onClick={() => handleClose()} style={{width: '12px'}} />
        </Box>

        <Box display='flex' direction='column' margin='20px 0'>
          <Typography variant='span' size='14px' color='#344054'>
            Informe a placa do veículo
          </Typography>

          <Typography variant='span' size='12px' color='#98A2B3'>
            Utilize somente números e letras. Exemplo: ABC1234
          </Typography>
        </Box>

        <Box height='90%' display='flex' direction='column' justifyContent='space-between'>
          <Box display='flex' direction='column' rowGap='40px'>
            <Input.Root
              labelFontSize='14px'
              height='40px'
              borderColor='#D0D5DD'
              fontSize='12px'
              labelFontWeight='400'
              label='Placa'
              onChange={(e) => {
                plateIsValid(e.target.value)
              }}
              mask={(value) => value.toUpperCase()}
              required
            />
            <Input.Root
              labelFontSize='14px'
              height='40px'
              borderColor='#D0D5DD'
              fontSize='12px'
              labelFontWeight='400'
              label='Descrição'
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </Box>
          <Box display='flex' direction='row' columnGap='10px' align='center' justify='flex-end' paddingTop='20px'>
            <Button fontSize='12px' height='38px' width='120px' variant='outlined' color='#8E8E8E' onClick={() => handleClose()}>
              Cancelar
            </Button>
            <Button
              fontSize='12px'
              height='38px'
              width='120px'
              disabledTextColor='#8E8E8E'
              disabled={!!errorMessage || !plate || !description}
              onClick={() => handleSaveList()}>
              Salvar
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default CreatePlateModal
